// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import { createHook } from '@atlassian/react-sweet-state';
import { functionWithCondition } from '@atlassian/jira-feature-flagging-utils';
import { fg } from '@atlassian/jira-feature-gating';
import { EpicsStore } from '../main.tsx';
import type { EpicCardType, State } from '../types.tsx';

export const useEpicsStoreActions = createHook(EpicsStore, {
	selector: null,
});

const getEpicsStoreIsInitialised = (state: State) => state.isInitialised;
export const useEpicsStoreIsInitialised = createHook(EpicsStore, {
	selector: getEpicsStoreIsInitialised,
});

const getHasFullFetchStarted = (state: State) => state.hasFullFetchStarted;
export const useHasFullFetchStarted = createHook(EpicsStore, {
	selector: getHasFullFetchStarted,
});

export const getEpicIssueType = (state: State) => state.epicIssueType;
export const useEpicIssueType = createHook(EpicsStore, {
	selector: getEpicIssueType,
});

export const getEpicIssueTypeName = (state: State) => state.epicIssueTypeName;
export const useEpicIssueTypeName = createHook(EpicsStore, {
	selector: getEpicIssueTypeName,
});

export const getTimeTrackingOptions = (state: State) => state.timeTrackingOptions;
export const useTimeTrackingOptions = createHook(EpicsStore, {
	selector: getTimeTrackingOptions,
});

export const getIsRankingEnabled = (state: State) => state.isRankingEnabled;
export const useIsRankingEnabled = createHook(EpicsStore, {
	selector: getIsRankingEnabled,
});

export const getEpicCardsState = (state: State) => ({
	cards: state.cards,
	cardsWithFullDetailsLoaded: state.cardsWithFullDetailsLoaded,
	loading: state.loading,
	error: state.error,
	refetchError: state.refetchError,
});
export const useEpicCardsState = createHook(EpicsStore, {
	selector: getEpicCardsState,
});

/* -------------- These selectors are used for the backlog epic filter -------------- */
type CompatibleStateType = {
	cards: EpicCardType[];
	isLoading: boolean | undefined;
	epicIssueTypeName: string;
	isEpicIssueTypeAvailable: boolean;
};
const getEpicsFilterDataOld = (state: State): CompatibleStateType => ({
	cards: state.cards,
	isLoading: undefined,
	epicIssueTypeName: state.epicIssueTypeName,
	isEpicIssueTypeAvailable: state.isEpicIssueTypeAvailable,
});
const useEpicsFilterDataOld = createHook(EpicsStore, {
	selector: getEpicsFilterDataOld,
});
// rename when cleaning up `update_filter_bar_state_logic_initial_render`
const getEpicsFilterDataNew = (state: State): CompatibleStateType => ({
	cards: state.cards,
	isLoading: state.loading,
	epicIssueTypeName: state.epicIssueTypeName,
	isEpicIssueTypeAvailable: state.isEpicIssueTypeAvailable,
});
// rename when cleaning up `update_filter_bar_state_logic_initial_render`
const useEpicsFilterDataNew = createHook(EpicsStore, {
	selector: getEpicsFilterDataNew,
});
export const useEpicsFilterData = functionWithCondition(
	() => fg('update_filter_bar_state_logic_initial_render'),
	useEpicsFilterDataNew,
	useEpicsFilterDataOld,
);

export const getEpicIssueTypeAvailable = (state: State) => state.isEpicIssueTypeAvailable;
export const useEpicIssueTypeAvailable = createHook(EpicsStore, {
	selector: getEpicIssueTypeAvailable,
});
